<template>
  <b-alert
    ref="logAs"
    id="log-as"
    :show="isLoggedAs"
    dismissible
    variant="info"
    class="mb-0 fixed-top log-as"
    @dismissed="existLogAs"
  >
    You are connected as <strong>{{this.$store.getters["auth/fullName"]}} ({{this.$store.getters["auth/role"]}})</strong>
  </b-alert>
</template>

<script>
  export default {
    name: "AppLoggedAs",
    computed: {
      isLoggedAs() {
        return this.$store.getters['auth/isLoggedAs']
      },
    },
    methods: {
      existLogAs() {
        this.$store.dispatch("loader/showLoadApp");
        this.$store.dispatch("auth/existLogAs");
        this.$store.dispatch("timesheets/changeTimesheetIdsAreLoaded", false);
        this.$store.dispatch("timesheets/changeAwaitingSubmissionTimesheet", []);
        this.$store.dispatch("timesheets/changeSubmittedTimesheets", []);
        this.$store.dispatch("timesheets/changeAwaitingApprovalTimesheets", []);
        this.$store.dispatch("timesheets/changeApprovedTimesheets", []);

        this.$router.push({name: this.$getConst.routesNames.administration.users}).then(
          () => this.$store.dispatch("loader/hideLoadApp")
        );

        window.location.reload();

        this.$store.dispatch("auth/updateConnectedRole", null);
      }
    }
  }
</script>

<style scoped>

</style>
